import Reveal from '@/components/base/Reveal';
import { whoFor } from '@/mocks/home';

export default function WhoFor() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100/40">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            Who We Work Best With
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Built for Serious, Growth-Minded Businesses
          </h2>
          <p className="mt-4 text-foreground-600">
            Josh works best with established owners and teams who already have
            traction and want predictable, measurable growth — not tire-kickers.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {whoFor.map((item, i) => (
            <Reveal key={item.title} delay={i * 60}>
              <div className="h-full rounded-xl border border-white/8 bg-background-50 p-6">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="mt-5 font-heading font-semibold text-base text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
